/**
 * Bootstrap Modal for widgets
 */
/**
	Add line in beginning checking for existing modal() function in case of bootstrap already existing


	Section of modal code:

	this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    was edited so that third line reads:

    if ($(e.target).is('#'+that.$element.attr('id'))) that.ignoreBackdropClick = true

    to support Zepto in the feedback widget because Zepto only takes selectors as the argument for .is()
 */
/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  if (typeof $.fn.modal !== 'undefined') { return; }

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.4.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is('#'+that.$element.attr('id'))) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    var scrollbarWidth = this.scrollbarWidth
    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth)
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight
        var calculatedPadding = $(element).css('padding-right')
        $(element)
          .data('padding-right', actualPadding)
          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
      })
    }
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right')
      $(element).removeData('padding-right')
      element.style.paddingRight = padding ? padding : ''
    })
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var target = $this.attr('data-target') ||
      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7

    var $target = $(document).find(target)
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(springSpace.jq);
;
/**
 * UI element: Drag and drop file upload inteface
 * requires: jquery, s-ui-filedrop css file
 */
var springSpace = springSpace || {};
springSpace.sui = springSpace.sui || {};

/**
 * Constructor
 * @param {Object} config Configuration object
 * @param {String} config.selector Selector for the form that contains the filedrop
 * @param {Function} config.callback Success callback for the form submission
 * @param {Function} [config.error_callback] Error callback for the form submission
 * @param {Function} [config.validate] Validation to be called on form submission
 * @param {Number} [config.max_files=0] maximum number of uploads allowed 0=unlimited
 * @param {Number} [config.max_upload_size=0] maximum bytes you can upload to the server at once (probably set in nginx or php or both) 0=unlimited (i.e. don't check)
 * @param {Number} [config.max_file_size=0] maximum bytes for a single file 0=unlimited (i.e. don't check)
 * @param {Boolean} [config.batch_files=false] should files be batched and uploaded in groups if they exceed the max_upload_size
 * @param {Boolean} [config.autoupload=true] automatically submit the form when a file is dropped/added
 * @param {Object} [config.translations] Language values for various messages.
 * @param {Array} [config.allowedMimeTypes] Mime types of files that are allowed. Empty/unset means any.
 * @param {Array} [config.allowedFileExtensions] File extensions that are allowed. Empty/unset means any.
 * @return {Object}
 */
springSpace.sui.filedrop = function(config) {
    if (typeof config === 'undefined') { return false; }
    if (!config.selector || config.selector === '') { return false; }

    let defaultTranslations = {
        max_file_size: 'Maximum file size',
        invalidExtension: 'File is not an allowed file type: ',
    };

    this.callback = (config.callback) ? config.callback : function() {};
    this.error_callback = (config.error_callback) ? config.error_callback : function() {};
    this.validate = (config.validate) ? config.validate : function() { return true; };
    this.max_files = (config.max_files) ? parseInt(config.max_files, 10) : 0;
    this.max_upload_size = (config.max_upload_size) ? parseInt(config.max_upload_size, 10) : 0;
    this.max_file_size = (config.max_file_size) ? parseInt(config.max_file_size, 10) : 0;
    this.batch_files = (typeof config.batch_files !== 'undefined') ? !!config.batch_files : false;
    this.autoupload = (typeof config.autoupload !== 'undefined') ? !!config.autoupload : true;
    this.translations = (config.translations) ? Object.assign(defaultTranslations, config.translations) : defaultTranslations;
    this.allowedMimeTypes = (config.allowedMimeTypes) ? config.allowedMimeTypes : [];
    this.allowedFileExtensions = (config.allowedFileExtensions) ? config.allowedFileExtensions : [];

    /**
     * Can we use the advanced features
     * This will mostly just exclude IE9< I think or people with super archaic FF/Chrome/Safari
     * self invoking function
     * @prop {bool}
     */
    this.isAdvancedUpload = function() {
        var div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
            && 'FormData' in window
            && 'FileReader' in window;
    }();

    /**
     * Get the form
     */
    this.$form = springSpace.jq(config.selector);
    if (this.$form.length === 0) { return false; }

    /**
     * This is a div containing the label and input[type=file]
     */
    this.$droparea = this.$form.find('.s-ui-filedrop');

    /**
     * Tracking files that have been dropped to be uploaded
     */
    this.droppedFiles = [];
    /**
     * Files batched into groups so they dont go over the max_upload_size
     */
    this.batchedFiles = [];
    /**
     * Tracking batch progress
     */
    this.batch = { current: 0, total: 0 };

    /**
     * For binding this in events until we can finally use arrow functions
     */
    var self = this;

    /**
     * The actual file input
     */
    this.$input = this.$droparea.find('input[type="file"]');
    /**
     * The label for the file input
     */
    this.$label = this.$droparea.find('label');
    /**
     * Form submit button
     */
    this.$submitbutton = this.$form.find('button[type="submit"]');
    /**
     * Progress bar
     */
    this.$progress = null;

    /**
     * Update the label to show file names
     */
    this.showFiles = function() {
        if (this.$input.length === 0) { return; }

        var fileArea = this.$droparea[0].querySelector('.s-ui-filedrop-filenames');
        var fileList = fileArea.querySelector('ul');

        if (this.isAdvancedUpload) {
            var fileItems = [];
            var total_size = 0;
            this.droppedFiles.forEach(function(file) {
                var item = document.createElement('li');
                item.innerText = file.name;
                fileItems.push(item);
                total_size += file.size;
            });

            fileList.innerHTML = '';
            if (fileItems.length === 0) {
                fileArea.classList.add('hidden');
            } else {
                fileArea.classList.remove('hidden');
                fileItems.forEach(function(li) {
                    fileList.appendChild(li);
                });
            }
            if (this.max_files > 0 && fileItems.length > this.max_files) {
                this.showError(self.max_files + ' file uploads maximum.');
            }
            if (this.batch_files === false && this.max_upload_size > 0 && total_size > this.max_upload_size) {
                this.showError('Files total ' + self.bytesToMB(total_size)
                    + ' MB which exceeds the maximum of ' + self.bytesToMB(this.max_upload_size) + ' MB at a time.');
            }
        } else {
            // only 1 file would be allowed in older browsers
            if (this.$input.val() === '') {
                fileArea.classList.add('hidden');
                fileList.innerHTML = '';
                return;
            }
            fileArea.classList.remove('hidden');
            var item = document.createElement('li');
            item.innerText = this.$input.val().split('\\').slice(-1).pop();
            fileList.appendChild(item);
            this.$label.find('.filetext').addClass('hidden');
        }
    };
    /**
     * Resets the form and files and errors
     */
    this.reset = function() {
        self.$form[0].reset();
        self.removeError();
        self.droppedFiles = [];
        self.batch.current = 0;
        self.batch.total = 0;
        self.stopProgress();
        self.showFiles();
        self.$input.removeClass('has-focus');
    };
    /**
     * Clear the files only
     */
    this.clearFiles = function() {
        self.resetFileInput();
        self.droppedFiles = [];
        self.batch.current = 0;
        self.batch.total = 0;
        self.showFiles();
    };
    /**
     * Reset the input[type=file]
     * the only way to clear a input[type=file] is to reset the whole form or remove/clone the input.
     * For this we will remove/clone, FF won't remove the value/files with a straight clone so we are cloning to a temp form,
     * resetting it, then moving the cloned input to the real form.
     */
    this.resetFileInput = function() {
        if (this.$input.length === 0) { return; }
        var $temp_form = springSpace.jq('<form>');
        var $newinput = this.$input.clone(true).appendTo($temp_form);
        $temp_form[0].reset();
        this.$input.replaceWith($newinput);
        this.$input = $newinput;
    };
    /**
     * Show an error alert inside the drop area (good for file related errors)
     * @param {String} msg An error message
     */
    this.showError = function(msg) {
        if (this.$droparea.length === 0) { return; }
        var msgEl = document.createElement('p');
        msgEl.innerText = msg;
        if (this.$form.find('div.s-ui-filedrop-error').length > 0) {
            this.$form.find('div.s-ui-filedrop-error').append( msgEl );
            return;
        }
        var alert = document.createElement('div');
        alert.classList.add('alert');
        alert.classList.add('alert-danger');
        alert.classList.add('s-ui-filedrop-error');
        alert.setAttribute('role', 'alert');
        alert.appendChild(msgEl);
        this.$droparea.prepend(alert);
    };
    /**
     * Empty the error div, which because of the css will cause it to disappear
     */
    this.removeError = function() {
        this.$form.find('div.s-ui-filedrop-error').empty();
    };
    /**
     * Count how many files have been added to widget
     * @return {Number}
     */
    this.countFiles = function() {
        if (this.$input.length === 0) {
            return 0;
        }
        if (!this.isAdvancedUpload) {
            return (this.$input.val() !== '') ? 1 : 0;
        }
        return this.droppedFiles.length;
    };
    /**
     * Rev up the progress bar so we can start updating it
     */
    this.startProgress = function() {
        if (this.$progress === null || (this.$progress.length === 1 && this.$progress.html() === '')) {
            var existing = true;
            this.$progress = this.$form.find('div.s-ui-filedrop-progress');
            if (this.$progress.length === 0) {
                existing = false;
                this.$progress = springSpace.jq('<div></div>').addClass('s-ui-filedrop-progress');
            }
            var $label = springSpace.jq('<div></div>').attr({ id: 's-ui-filedrop-progresslabel' }).text('Uploading files');
            var $bar = springSpace.jq('<div></div>')
                .addClass('s-ui-filedrop-progbar')
                .attr({
                    role: 'progressbar',
                    'aria-valuenow': '0',
                    'aria-valuemin': '0',
                    'aria-valuemax': '100',
                    'aria-labelledby': 's-ui-filedrop-progresslabel'
                });
            $bar.append( document.createElement('span') );
            this.$progress.append([$label, $bar]);
            // if the progress bar was not already in the page, we should inject it into the drop area
            if (!existing) {
                this.$droparea.prepend( this.$progress );
            }
        }
    };
    /**
     * Update the progress bar, if there is none, add it.
     * @param {number} loaded bytes uploaded
     * @param {number} total total bytes to upload
     */
    this.updateProgress = function(loaded, total) {
        var val = Math.round(loaded / total * 100);
        this.$progress.find('span:first').css('width', val + '%');
        this.$progress.find('.s-ui-filedrop-progbar').attr('aria-valuenow', val);
        if (this.batch.total > 1 && val < 50) {
            var $label = this.$progress.find('div:first');
            $label.html('Uploading file batch (' + this.batch.current + '/' + this.batch.total + ')');
        }
    };
    /**
     * Stop the progress bar (i.e. close/hide it)
     */
    this.stopProgress = function() {
        if (this.$progress !== null) {
            this.$progress.empty();
        }
    };
    /**
     * Convert bytes to MB
     * @param {Number} bytes File in bytes.
     * @return {Number} MB
     */
    this.bytesToMB = function(bytes) {
        return (parseInt(bytes, 10) / (1024 * 1024)).toFixed(1);
    };
    /**
     * Add files from a FileList to the droppedFiles array
     * checking size limitations in the process
     * @param {FileList} filelist A FileList object (Array-like)
     * @return {Boolean}
     */
    this.addFiles = function(filelist) {
        if (self.max_files > 0 && (self.countFiles() + filelist.length) > self.max_files) {
            self.showError(self.max_files + ' file uploads maximum.');
            return false;
        }
        var total_size = 0;
        self.droppedFiles.forEach(function(f) {
            total_size += f.size;
        });

        var invalid_file_indexes = [];
        for (var i = 0; i < filelist.length; i++) {
            var file = filelist[i];

            if (self.droppedFiles.length > 0) {
                //check for dupes by filename
                var dupe = false;
                self.droppedFiles.forEach(function(f) {
                    if (f.name === file.name) {
                        dupe = true;
                    }
                });
                if (dupe) {
                    invalid_file_indexes.push(i);
                    continue;
                }
            }

            if (this.allowedFileExtensions.length > 0) {
                let extension = file.name.split('.').pop();

                if (this.allowedFileExtensions.indexOf(extension) === -1) {
                    self.showError(this.translations.invalidExtension + file.name);
                    invalid_file_indexes.push(i);
                    continue;
                }
            }

            // check for mime-type constraints
            if (this.allowedMimeTypes.length > 0
                && this.allowedMimeTypes.indexOf(file.type) === -1) {
                self.showError('File: ' + file.name + ' is not an allowed file type.');
                invalid_file_indexes.push(i);
                continue;
            }

            if (self.max_file_size > 0 && file.size > self.max_file_size) {
                self.showError('File: ' + file.name + ' is greater than allowed file size of '
                    + self.bytesToMB(self.max_file_size) + ' MB.');
                invalid_file_indexes.push(i); //can't edit filelist so we just have to track which files to ignore later
            } else if (self.batch_files === false && total_size + file.size > self.max_upload_size) {
                self.showError('File: ' + file.name + ' causes files to go over maximum upload size of '
                    + self.bytesToMB(self.max_upload_size) + ' MB at a time.');
                invalid_file_indexes.push(i);
            } else {
                total_size += file.size;
            }
        }
        if (self.batch_files === false && self.max_upload_size > 0 && total_size > self.max_upload_size) {
            self.showError('Files total ' + total_size + ' bytes which exceeds the maximum of '
                + self.bytesToMB(self.max_upload_size) + ' MB at a time.');
            return false;
        }

        for (var x = 0; x < filelist.length; x++) {
            if (invalid_file_indexes.indexOf(x) !== -1) { continue; }
            self.droppedFiles.push( filelist[x] );
        }
        if (self.droppedFiles.length === 0) {
            return false;
        }
        return true;
    };
    /**
     * Create an array of batched files
     * @return {Array}
     */
    this.batchFiles = function() {
        var b = [];
        var sizes = [];

        if (!this.batch_files) {
            b.push(this.droppedFiles);
            return b;
            //???
        }
        var batches = 1;
        b.push([]);
        sizes.push(0);
        this.droppedFiles.forEach(function(file) {
            var added = false;
            sizes.forEach(function(s, i) {
                if (!added && (s + file.size) < self.max_upload_size) {
                    sizes[i] = s + file.size;
                    b[i].push(file);
                    added = true;
                }
            });
            if (!added) {
                sizes.push(0);
                batches++;
                b.push([]);
                var i = batches - 1;
                sizes[i] = file.size;
                b[i].push(file);
            }
        });
        return b;
    };
    /**
     * Are we on the last batch
     * @return {Boolean}
     */
    this.isLastBatch = function() {
        return this.batch.current >= this.batch.total;
    };
    /**
     * Ajax upload event
     * For batches of files this will get called for each batch
     */
    this.ajaxUpload = function() {
        // set current batch number (so processing scripts can deal appropriately)
        self.$form.find('input[name="batch_current"]').val(self.batch.current);

        var ajaxData = new FormData(self.$form[0]);
        // Clear out empty form input... Safari hates the empty one.
        // Make sure delete is supported (it is in at least the latest Safari where we need it.)
        if (typeof ajaxData.delete === 'function') {
            ajaxData.delete(self.$input.attr('name'));
        }
        // add the current batch of files to the formdata (if no batches this is just all the files)
        self.batchedFiles[self.batch.current - 1].forEach(function(file) {
            ajaxData.append( self.$input.attr('name'), file );
        });

        springSpace.jq.ajax({
            url: self.$form.attr('action'),
            type: self.$form.attr('method'),
            data: ajaxData,
            dataType: 'json',
            cache: false,
            crossDomain: true,
            contentType: false,
            processData: false,
            beforeSend: function() {
                // only if we have files!
                if (self.countFiles() > 0) {
                    self.startProgress();
                }
            },
            complete: function() {
                if (self.isLastBatch()) {
                    self.$form.removeClass('is-uploading');
                    self.$submitbutton.prop('disabled', false);
                    self.stopProgress();
                } else {
                    self.batch.current++;
                    // @todo update file list to show which were uploaded in the batch
                    self.ajaxUpload();
                }
            },
            success: function(data) {
                self.callback(data, self);
            },
            xhr: function() {
                // get the native XmlHttpRequest object
                var xhr = springSpace.jq.ajaxSettings.xhr();
                if (self.countFiles() > 0) {
                    // doing this causes CORS requests to preflight
                    xhr.upload.onprogress = function(e) {
                        self.updateProgress(e.loaded, e.total);
                    };
                }
                return xhr;
            }
        }).fail(function(jqxhr) {
            self.error_callback(jqxhr, self);
        });
    };

    /**
     * If available add the drag/drop event handlers
     */
    if (this.isAdvancedUpload && this.$input.length > 0) {
        this.$droparea.addClass('has-advanced-upload');

        // inject inputs for batch file data if appropriate
        if (this.batch_files) {
            var $input1 = springSpace.jq('<input />').attr({
                type: 'hidden',
                name: 'batch_current'
            }).val('0');
            var $input2 = springSpace.jq('<input />').attr({
                type: 'hidden',
                name: 'batch_total'
            }).val('0');
            this.$form.prepend([$input1, $input2]);
        }

        this.$droparea.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
            .on('dragover dragenter', function() {
                self.$droparea.addClass('is-dragover');
            })
            .on('dragleave dragend drop', function() {
                self.$droparea.removeClass('is-dragover');
            })
            .on('drop', function(e) {
                var adding = self.addFiles(e.originalEvent.dataTransfer.files);
                self.showFiles();
                if (adding === true && self.autoupload) {
                    self.$form.submit();
                }

            }).on('click', function(e) {
                // delegate for various functions
                var tags = ['A', 'I', 'SPAN', 'B', 'STRONG', 'BUTTON'];
                var tag = e.target.tagName;
                //links and possible children of links
                if (tags.indexOf(tag) !== -1) {
                    var $link = springSpace.jq(e.target).closest('a, button');
                    if ($link.hasClass('s-ui-filedrop-clear')) {
                        // clear files button
                        self.clearFiles();
                        self.removeError();
                    }
                }
            });
    }

    if (!this.isAdvancedUpload) {
        this.$input.remove();
        this.$droparea.remove();
    }

    /**
     * For when files are added using the normal input
     * also a class to help with focus management for keyboard users
     */
    if (this.$input.length > 0) {
        this.$input.on('change', function(e) {
            if (e.target.files) {
                if (self.isAdvancedUpload) {
                    var adding = self.addFiles(e.target.files);
                    self.resetFileInput();
                    if (adding === true && self.autoupload) {
                        self.$form.submit();
                    }
                }
                self.$input.removeClass('has-focus');
                self.showFiles();
            }
        })
            .on('focus', function(e) {
                e.target.classList.add('has-focus');
            })
            .on('blur', function(e) {
                e.target.classList.remove('has-focus');
            });

        // add a warning about max files size if the translation has been included (?)
        if (this.translations.max_file_size) {
            var warning = document.createElement('p');
            warning.innerHTML = this.translations.max_file_size + ': ' + this.bytesToMB(this.max_file_size) + ' MB';
            this.$label.append(warning);
        }
    }

    /**
     * Form submit
     */
    this.$form.on('submit', function(e) {
        // don't preventdefault here as the legacy ajax support requires submitting the form
        if (self.$form.hasClass('is-uploading')) {
            e.preventDefault();
            return;
        }

        self.$form.removeClass('is-error');
        self.removeError();

        if (self.max_files > 0 && self.countFiles() > self.max_files) {
            self.showError(self.max_files + ' file uploads maximum.');
            e.preventDefault();
            return;
        }

        if (self.validate(self) === false) {
            self.$form.addClass('is-error');
            e.preventDefault();
            return;
        }

        self.$form.addClass('is-uploading');
        self.$submitbutton.prop('disabled', true);

        if (self.isAdvancedUpload) {
            e.preventDefault();
            // setup batch file
            self.batch.current = 1;
            self.batchedFiles = self.batchFiles();
            self.batch.total = self.batchedFiles.length;

            self.$form.find('input[name="batch_total"]').val(self.batch.total);

            //this will iterate as necessary over the batches
            self.ajaxUpload();
        } else {
            // ajax no files for legacy
            e.preventDefault();

            springSpace.jq.ajax({
                url: self.$form.attr('action'),
                type: self.$form.attr('method'),
                data: self.$form.serialize(),
                dataType: 'json',
                complete: function() {
                    self.$form.removeClass('is-uploading');
                    self.$submitbutton.prop('disabled', false);
                },
                success: function(data) {
                    self.callback(data, self);
                }
            }).fail(function(jqxhr) {
                self.error_callback(jqxhr, self);
            });
        }
    });
};

/*
    Example usage:

    You must start with a form with method="POST" and enctype="multipart/form-data"
    the form's action attribute should be set to the url you want to send the form/file data to

    The file area itself should be a div.s-ui-filedrop containing an input[type=file] and a label (in that order). It's also best to include a "clear file" button.s-ui-filedrop-clear

    Example:

    <div class="form-group s-ui-filedrop">
        <input type="file" name="file_uploads[]" id="file_uploads" value="" class="sr-only" multiple />
        <label for="file_uploads" class="btn btn-default"><div><i class="fa fa-upload fa-3x"></i></div><span class="filetext"><strong>Choose a file</strong><span class="s-ui-filedrop-dragtext"> or drag it here</span>.</span></label>
        <div class="s-ui-filedrop-filenames hidden"><strong>Selected Files:</strong><ul></ul></div>
        <button type="button" class="btn btn-default btn-xs s-ui-filedrop-clear">Clear Files</button>
    </div>

    Replace "file_uploads" as appopriate for your processing script.
    The FA icon can be changed or removed.
    The text can be changed but the classes should remain the same.
    The clear button is optional, but allows for clearing the files that have been dropped in or selected via the input.
    If you want the progress to appear elsewhere on your form just add a div.s-ui-filedrop-progress that will get used to show the progress bar. It needs to be inside the form though.

    Instantiate with:

    var fileform = new springSpace.sui.filedrop({
        selector: '#someform', // selector for the form,
        max_files: 5, // total files that can be uploaded at a time
        max_upload_size: 0, // max TOTAL upload size in bytes (usually an nginx/php limitation), if using batch_requests, this is the maximum size of each batch, make sure this is slightly smaller than the nginx/php settings as this code is only comparing to the files not any other content sent with the request
        max_file_size: 0, // max single file size in bytes (usually a php limitation)
        allowedMimeTypes: ['image/jpeg', 'image/gif', 'image/png'], // limit types of uploads. Leave unset to allow any type.
        batch_files: true, // if multiple files go over the max_upload_size (but are individually under the max_File_size) then this will cause a series of ajax upload events to occur. WARNING: if you do this you must make sure your processing scripts and callbacks are accounting for multiple form submissions.
        callback: function(data) {
            // do some processing with the data returned from the script.
            // 'this' will reference the s-ui-filedrop object, unless you pass a bound function in which case the s-ui-filedrop object will be passed as the second argument to the callback.
            // data will be the JSON parsed response from the server
            // s-ui-filedrop object will be passed as the second argument
            // NOTE: If using batch uploads this callback MAY be called multiple times. Use isLastBatch() on the s-ui-filedrop object to know if this is the final request/upload
            //
        },
        error_callback: function(jqxhr) {
            // optional
            // this is called as the argument for springSpace.jq ajax fail event
            // so it's when the server doesnt return a 200 response
            // jqxhr object is first argument
            // s-ui-filedrop object will be passed as the second argument
            // you can call reset() on the s-ui-filedrop object to clear the form and all files.
            // NOTE: If using batch uploads this callback MAY be called multiple times. Use isLastBatch() on the s-ui-filedrop object to know if this is the final request/upload
        },
        validate: function() {
            // optional
            // this is called before the ajax event is started
            // return false from this function to stop the ajax event from starting (i.e. fail validation)
            // the s-ui-filedrop object will be passed as the first argument to the validate function.
            // throw file errors with showError(msg) on the s-ui-filedrop object
            // for batch uploads this is only called before any of the ajax requests start. If you want to validate files in some custom way use the droppedFiles array of File items on the s-ui-filedrop object
        }
    });

    NOTE Batch uploads:
    When batch uploads are enabled the form will POST batch_current and batch_total values along with other form content. You can use this to know if there will be batches of the same form submitted

    NOTE Crossdomain Usage:
    Using CORS you can do crossdomain file uploads, but be aware that the progress bar code will force the a preflight check on the CORS request. The preflight is an OPTIONS request to the url you only need to return a 200 code, your normal headers, and your "Access-Control-Allow-Origin" header. That will let the browser know it is ok to send the real request. (So in dev tools Networking you will see two requests to the submit url.

*/
;
/**
  * Centered floating alerts
  */
// This is in block scope because it gets concatenated into LA Widgets, so we need the class def to be non-global in case it gets loaded twice
// Once we move to all imports/modules/builds we could remove that.
{
    class Notify {
        #parent = null;
        #defaultParentId = 's-ui-notifyarea';
        #defaultAlertId = 's-ui-notify';
        #defaultClassname = 's-ui-notify';
        #workingConfig = {
            msg: '<i class="fa fa-spinner fa-pulse mg-right" aria-hidden="true"></i> <span>Working...</span>',
            className: 's-ui-notify-working'
        };
        #successConfig = {
            msg: 'Success.',
            className: 's-ui-notify-success'
        };
        #errorConfig = {
            msg: 'Error: Please try again.',
            className: 's-ui-notify-error'
        };

        #idCount = 0;
        #boundKeyboardEvents = null;

        constructor({
            parent_id = null
        }) {
            // Its best for screenreaders if the parent is already in the DOM.
            if (parent_id) {
                this.#defaultParentId = parent_id;
            }
        }

        #setUpParent() {
            let parent = document.getElementById(this.#defaultParentId);
            if (!parent) {
                parent = document.createElement('DIV');
                parent.id = this.#defaultParentId;
                parent.setAttribute('role', 'alert');
                parent.setAttribute('aria-atomic', 'true');
                document.body.appendChild(parent);
            }
            return parent;
        }
        /**
         * @returns {HTMLElement}
         */
        #getParent() {
            if (!this.#parent) {
                this.#parent = this.#setUpParent();
            }
            return this.#parent;
        }
        /**
          * A default error alert
          * @param {String} [msg] Custom error message
          * @param {String} [id] Alert id to replace, else new alert created.
          */
        error(msg = '', id = null) {
            const config = { ...this.#errorConfig };
            if (msg) {
                config.msg = msg;
            }
            config.msg = `<i class="fa fa-exclamation-triangle mg-right" aria-hidden="true"></i> ${config.msg}`;
            config.id = id;
            this.show(config);
        }
        /**
          * A default success alert
          * @param {String} [msg] Custom success message
          * @param {String} [id] Alert id to replace, else new alert created.
          * @param {Number} [ms] Timeout in milliseconds
          */
        success(msg = '', id = null, ms = 0) {
            const config = { ...this.#successConfig };
            if (msg) {
                config.msg = msg;
            }
            if (ms > 0) {
                config.ms = ms;
            }
            config.msg = `<i class="fa fa-check-circle mg-right" aria-hidden="true"></i> ${config.msg}`;
            config.id = id;
            this.show(config);
        }
        /**
          * default "working" alert
          * @param {String} [msg] custom message
          * @param {String} [id] Alert id to replace, else new alert created.
          */
        working(msg = '', id = null) {
            const config = { ...this.#workingConfig };
            if (msg) {
                config.msg = msg;
            }
            config.id = id;
            this.show(config);
        }
        /**
          * Creates/displays an alert
          * @param {Object} settings Alert config
          * @param {String} settings.msg message to display
          * @param {String} [settings.className=s-ui-notification] custom class to attach to alert (for styling)
          * @param {String} [settings.id] Id for alert
          * @param {Number} [settings.ms] Timeout in ms
          * @returns {String} alert id
          */
        show({
            msg = '',
            className = null,
            id = null,
            ms = 0
        }) {
            if (!msg) {
                return null;
            }
            let el = null;
            if (!id) {
                this.#idCount++;
                id = `${this.#defaultAlertId}-${this.#idCount}`;
            } else {
                el = document.getElementById(id);
                if (el) {
                    el.remove();
                }
            }
            el = document.createElement('DIV');
            el.id = id;
            el.classList.add(this.#defaultClassname);
            if (className) {
                el.classList.add(className);
            }
            el.innerHTML = `<div class="s-ui-notification-message">${msg}</div><button class="btn" aria-label="${window?.springyText?.modal?.close || 'Close'}">&times;</button>`;

            const parent = this.#getParent();
            parent.appendChild(el);
            el.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.hide(ev.currentTarget);
            });
            if (ms > 0) {
                setTimeout(() => {
                    this.hide(el);
                }, ms);
            }
            // add a close keyboard action
            if (this.#boundKeyboardEvents === null) {
                this.#boundKeyboardEvents = this.keyboardEvents.bind(this);
                document.addEventListener('keydown', this.#boundKeyboardEvents, true);
            }
            return id;
        }
        /**
          * Hide a notification or all notifications
          * @param {HTMLElement|null} [alert=null] Alert to hide (else all)
          */
        hide(alert = null) {
            if (alert) {
                alert.remove();
            } else if (this.#parent) {
                this.#parent.innerHTML = '';
            }
            this.#removeKeyboardEvents();
        }
        /**
         * Hide any working alerts.
         */
        hideWorking() {
            if (!this.#parent) {
                return;
            }
            this.#parent.querySelectorAll(`.${this.#workingConfig.className}`).forEach((el) => {
                el.remove();
            });
            this.#removeKeyboardEvents();
        }
        /**
         * If there are no more alerts, turn off the keyboard close event
         */
        #removeKeyboardEvents() {
            if (this.#boundKeyboardEvents === null
                || !this.#parent
                || this.#parent.children.length > 0) {
                return;
            }
            document.removeEventListener('keydown', this.#boundKeyboardEvents, true);
            this.#boundKeyboardEvents = null;
        }
        /**
         * Handler: Keyboard event to:
         * - Close on Esc
         * @param {KeyboardEvent} ev Keydown event
         */
        keyboardEvents(ev) {
            if (ev.key !== 'Escape') {
                return;
            }
            // close the first/oldest alert first
            const firstAlert = this.#parent.querySelector(`.${this.#defaultClassname}`);
            if (firstAlert) {
                firstAlert.remove();
            }
            this.#removeKeyboardEvents();
        }
    }

    window.suiNotify = new Notify({});
}
;
/**
 * Autocomplete/Typeahead.
 * exports a function that initializes and returns an autocomplete object.
 * @deprecated Prefer the class in tools/SuiAutocomplete.js
 */

(function(root) {

    const autocomplete = {
        /**
         * @prop {HTMLElement} input Text input.
         */
        input: null,
        /**
         * @prop {HTMLElement} list Autocomplete list.
         */
        list: null,
        /**
         * @prop {String} listLabel Aria description for the list.
         */
        listLabel: 'Suggested results',
        /**
         * @prop {HTMLElement} instructions Screen reader instructions.
         */
        instructions: null,
        /**
         * @prop {Function} throttle Timeout function for throttling requests
         */
        throttle: null,
        /**
         * @prop {Object} xhrSearch Current search request object.
         */
        xhrSearch: null,
        /**
         * @prop {String} queryName Name of the query param from this.input['name']
         */
        queryName: '',
        /**
         * @prop {Function} queryProcessor Escapes or otherwise transforms typed data for query.
         */
        queryProcessor: null,
        /**
         * @prop {Function} dataProcessor Transforms returned data.
         */
        dataProcessor: null,
        /**
         * @prop {Function} selectCallback When an option is selected, this will run with the selected option as its arg.
         */
        selectCallback: null,
        /**
         * @prop {String} typedQuery The query as typed.
         */
        typedQuery: '',
        /**
         * @prop {Number} resultLimit Number of items to show.
         */
        resultLimit: 10,
        /**
         * @prop {Object} queryData Data to send with the query. Could be strings OR HTML input to retrieve values from.
         */
        queryData: {},
        /**
         * @prop {Array} staticData Data to use instead of querying a url.
         */
        staticData: [],
        /**
         * @prop {Boolean} preventSubmit Should we prevent form submission on "enter" in input.
         */
        preventSubmit: false,
        /**
         * @prop {String} instructionsText Text for screen reader instructions.
         */
        instructionsText: '{{count}} options available. Use up and down arrows to browse available options and enter to select one.',
        /**
         * @prop {Boolean} showAllOnFocus When focused the autocomplete will show the list for "all" (i.e. a blank search)
         */
        showAllOnFocus: false,
        /**
         * @prop {Boolean} allowEmptySearch Is a blank/empty search allowed (i.e. show all).
         */
        allowEmptySearch: false,
        /**
         * Select the next list item.
         */
        selectNext: function() {
            const current = this.list.querySelector('li[aria-selected=true]');
            let selected = null;
            if (current === null) {
                selected = this.list.querySelector('li:first-of-type');
                if (selected === null) {
                    return;
                }
            } else {
                selected = current.nextElementSibling;
                if (selected === null) {
                    return;
                }
                current.setAttribute('aria-selected', false);
            }

            selected.setAttribute('aria-selected', true);
            this.input.value = selected.textContent;
        },
        /**
         * Select the previous list item
         */
        selectPrevious: function() {
            const current = this.list.querySelector('li[aria-selected=true]');
            if (current === null) {
                return;
            }
            const selected = current.previousElementSibling;
            if (selected === null) {
                this.input.value = this.typedQuery;
            } else {
                selected.setAttribute('aria-selected', true);
                this.input.value = selected.textContent;
            }
            current.setAttribute('aria-selected', false);
        },
        /**
         * Select an item via clicking on it.
         * @param {HTMLElement} selected Option in list.
         */
        selectByClick: function(selected) {
            const prevSelected = this.list.querySelector('li[aria-selected=true]');
            if (prevSelected !== null) {
                prevSelected.setAttribute('aria-selected', false);
            }
            selected.setAttribute('aria-selected', true);
            this.selectOption();
            if (!this.showAllOnFocus) {
                this.input.focus();
            }
        },
        /**
         * Escape query for use in regex.
         * Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
         * Should be in some kind of utility module probably, but there is not one of those at this time.
         * @param {String} string String to escape.
         * @return {String}
         */
        escapeRegExp: function(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },
        /**
         * Format data object into HTMLElement
         * @param {Object} object Data object.
         * @return {HTMLElement|null}
         */
        formatOption: function(object) {
            let display = '';
            if (object.display) {
                display = object.display;
            } else {
                const regex = new RegExp(`(${this.escapeRegExp(this.typedQuery)})`, 'ig');
                display = object.label.replace(regex, '<strong>$1</strong>');
            }
            if (!display) {
                return null;
            }

            const option = document.createElement('li');
            option.setAttribute('aria-selected', false);
            option.setAttribute('role', 'option');
            Object.keys(object).forEach((prop) => {
                if (prop === 'label' || prop === 'display') {
                    return;
                }
                option.dataset[prop] = object[prop];
            });
            option.innerHTML = display;
            return option;
        },
        /**
         * Display results.
         * @param {Array} data Array of data objects.
         */
        displayResults: function(data) {
            if (data.length === 0) {
                this.closeList();
                return;
            }

            let options = data.map(this.formatOption, this);
            if (options.length > this.resultLimit && !this.allowEmptySearch) {
                options = options.slice(0, this.resultLimit);
            }
            this.list.innerHTML = '';

            const fragment = document.createDocumentFragment();
            options.forEach((element) => {
                if (!element) {
                    return;
                }
                fragment.appendChild(element);
            });

            this.list.appendChild(fragment);
            this.updateInstructions(options.length);
            this.openList();
        },
        /**
         * Is the list open
         * @return {Boolean}
         */
        isListOpen: function() {
            return !this.list.classList.contains('hidden');
        },
        /**
         * Is one of the options selected.
         * @return {Boolean}
         */
        isOptionSelected: function() {
            return this.list.querySelector('li[aria-selected=true]') !== null;
        },
        /**
         * Open the list.
         */
        openList: function() {
            this.list.style.left = `${this.input.offsetLeft}px`;
            this.list.style.top = `${this.input.offsetTop + this.input.offsetHeight}px`;
            this.list.style.minWidth = `${this.input.offsetWidth}px`;
            this.list.classList.remove('hidden');
            this.input.setAttribute('aria-expanded', true);
        },
        /**
         * Close the list
         */
        closeList: function() {
            this.list.classList.add('hidden');
            this.list.innerHTML = '';
            this.input.setAttribute('aria-expanded', false);
            this.updateInstructions(0);
        },
        /**
         * Select one of the list options.
         */
        selectOption: function() {
            const option = this.list.querySelector('li[aria-selected=true]');
            this.input.dataset.oldvalue = this.input.value;
            this.input.value = option.textContent;
            if (this.selectCallback !== null) {
                this.selectCallback(option);
            }
            this.closeList();
        },
        /**
         * Process the results if necessary.
         * Should have:
         * label text value of the item
         * display (optional) display html for the list
         * @param {Object|Array} data Data from the server.
         * @return {Array}
         */
        processData: function(data) {
            if (this.dataProcessor !== null) {
                return this.dataProcessor(data);
            }
            return data;
        },
        /**
         * Build a query string.
         * @return {String}
         */
        buildQueryString: function() {
            const rawTyped = this.input.value;
            const query = (this.queryProcessor !== null) ? this.queryProcessor(rawTyped) : rawTyped;
            const params = new URLSearchParams();
            params.append(this.queryName, query);
            params.append('limit', this.resultLimit);

            const props = Object.keys(this.queryData);
            props.forEach(function(prop) {
                const value = this.queryData[prop];
                if (typeof value === 'function') {
                    // dynamic param
                    params.append(prop, value());
                    return;
                }
                params.append(prop, value);
            }, this);
            return `?${params.toString()}`;
        },
        /**
         * On load for ajax request.
         */
        xhrOnLoad: function() {
            if (this.xhrSearch.status >= 200 && this.xhrSearch.status < 400) {
                // Success!
                const data = JSON.parse(this.xhrSearch.responseText);
                const formattedData = this.processData(data);
                this.displayResults(formattedData);
            } else {
                // We reached our target server, but it returned an error
                console.log(this.xhrSearch.statusText);
            }
        },
        /**
         * xhr error.
         */
        xhrOnError: function() {
            // There was a connection error of some sort
            console.log(this.xhrSearch.statusText);
        },
        /**
         * The ajax request.
         */
        makeRequest: function() {
            const queryString = this.buildQueryString();

            this.xhrSearch = new XMLHttpRequest();
            this.xhrSearch.open('GET', this.queryUrl + queryString, true);
            this.xhrSearch.setRequestHeader('Accept', 'application/json');
            this.xhrSearch.onload = this.xhrOnLoad.bind(this);
            this.xhrSearch.onerror = this.xhrOnError.bind(this);
            this.xhrSearch.send();
        },
        /**
         * Search the static data.
         */
        searchData: function() {
            const rawTyped = this.input.value;
            if (rawTyped === '' && !this.allowEmptySearch) {
                this.closeList();
                return;
            }
            let query = (this.queryProcessor !== null) ? this.queryProcessor(rawTyped) : rawTyped;
            query = query.toLowerCase();
            if (query === '') {
                this.displayResults(this.staticData);
                return;
            }
            const results = this.staticData.filter((option) => {
                return option.label.toLowerCase().indexOf(query) !== -1;
            });
            this.displayResults(results);
        },
        /**
         * Get exact match.
         * For when submitted without choosing the dropdown.
         * Only works with when staticData is set.
         * @returns {Object|null}
         */
        getExactMatch: function() {
            const rawTyped = this.input.value.trim().toLowerCase();
            if (rawTyped === '') {
                return null;
            }
            const result = this.staticData.find((option) => {
                return option.label.toLowerCase() === rawTyped;
            });
            if (!result) {
                return null;
            }
            return result;
        },
        /**
         * Inititiate a search.
         */
        query: function() {
            if (this.staticData.length > 0) {
                this.searchData();
                return;
            }
            if (this.throttle) {
                clearTimeout(this.throttle);
            }
            if (this.xhrSearch) {
                this.xhrSearch.abort();
            }
            if (this.input.value === '' && !this.allowEmptySearch) {
                this.closeList();
                return;
            }
            this.throttle = setTimeout(this.makeRequest.bind(this), 500);
        },
        /**
         * Destroy. Remove events, etc.
         */
        disable: function() {
            this.list.parentNode.removeChild(this.list);
            // this.input reset attributes, remove listeners
        },
        /**
         * Create the list to hold the results
         */
        createList: function() {
            this.list = document.createElement('ul');
            this.list.id = this.getListId();
            this.list.setAttribute('role', 'listbox');
            this.list.setAttribute('aria-label', this.listLabel);
            this.list.classList.add('s-ui-autocomplete-list');
            this.list.classList.add('hidden');
            // insert list after input
            this.input.parentNode.insertBefore(this.list, this.input.nextSibling);
        },
        /**
         * The list id based on the input id.
         * @return {String}
         */
        getListId: function() {
            return `${this.input.id}_list`;
        },
        /**
         * The instruction id based on the input id.
         * @return {String}
         */
        getInstructionsId: function() {
            return `${this.input.id}_instructions`;
        },
        /**
         * Add appropriate attributes to the input.
         */
        formatInput: function() {
            this.input.setAttribute('role', 'combobox');
            this.input.setAttribute('aria-autocomplete', 'list');
            this.input.setAttribute('aria-expanded', 'false');
            this.input.setAttribute('aria-controls', this.getListId());
            this.input.setAttribute('aria-describedby', this.getInstructionsId());
            this.input.setAttribute('autocomplete', 'off');
            this.queryName = this.input.getAttribute('name');
        },
        /**
         * Update instructions with number of options found.
         * @param {Number} count Number of options.
         */
        updateInstructions: function(count) {
            this.instructions.innerHTML = this.instructionsText.replace('{{count}}', count);
        },
        /**
         * Handler: Key down typing in the input, handles special commands.
         * @param {Event} ev Keyup event.
         */
        handleTypingDown: function(ev) {
            const open = this.isListOpen();
            switch (ev.key) {
                case 'Escape':
                    // if list is open, close it.
                    if (open) {
                        this.closeList();
                    }
                    break;
                case 'ArrowDown':
                    // if list is open, navigate to/select first entry.
                    if (open) {
                        ev.preventDefault();
                        this.selectNext();
                    } else if (this.showAllOnFocus && this.input.value === '') {
                        this.query();
                    }
                    break;
                case 'ArrowUp':
                    // if list is open, navigate to/select first entry.
                    if (open) {
                        ev.preventDefault();
                        this.selectPrevious();
                    }
                    break;

                case 'Enter':
                    if (open && this.isOptionSelected()) {
                        ev.preventDefault();
                        this.selectOption();
                    } else if (this.preventSubmit) {
                        ev.preventDefault();
                    }
                    break;
                case 'Tab':
                    if (open && this.isOptionSelected()) {
                        this.selectOption();
                    } else if (open) {
                        this.closeList();
                    }
                    // default action
                    break;
            }
        },
        /**
         * Handler: Key up typing in the input. Does the search
         * @param {Event} ev Keyup event.
         */
        handleTypingUp: function(ev) {
            switch (ev.key) {
                case 'Escape':
                case 'ArrowDown':
                case 'ArrowUp':
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'Enter':
                case 'Tab':
                    // ignore
                    break;
                default:
                    this.typedQuery = this.input.value;
                    this.query();
                    break;
            }
        },
        /**
         * Click events on the list of results.
         * @param {Event} ev Click event.
         */
        handleClick: function(ev) {
            const li = ev.target.closest('li[aria-selected=false]');
            if (li === null) {
                return;
            }
            this.selectByClick(li);
            return;
        },
        /**
         * Clicks on the document will close the list if outside the list or input itself.
         * @param {Event} ev Click event.
         */
        handleOutsideClick: function(ev) {
            const target = ev.target;
            if (target.closest(`#${this.list.id}`) === null && target.closest(`#${this.input.id}`) === null) {
                // click target is outside autocomplete
                this.closeList();
                return;
            }
        },
        /**
         * Attach events.
         */
        attachEvents: function() {
            this.input.addEventListener('keydown', this.handleTypingDown.bind(this));
            this.input.addEventListener('keyup', this.handleTypingUp.bind(this));
            this.list.addEventListener('click', this.handleClick.bind(this));

            // Warning: This handler will not get removed if the autocomplate is removed from the page
            // Ideally we should remove it, but that would require a MutationObserver that basically watches the whole page
            // Since the parent of the autoomplete isn't always the one that is explicitly removed (and thus wouldn't trigger the observer).
            document.body.addEventListener('click', this.handleOutsideClick.bind(this));

            if (this.showAllOnFocus) {
                this.input.addEventListener('focus', () => {
                    if (this.input.value === '') {
                        this.query();
                    }
                });
            }
        },
        /**
         * Add instructions div.
         */
        addInstructions: function() {
            this.instructions = document.createElement('div');
            this.instructions.id = this.getInstructionsId();
            this.instructions.setAttribute('aria-live', 'polite');
            this.instructions.classList.add('sr-only');
            this.instructions.innerHTML = this.instructionsText.replace('{{count}}', 0);

            this.list.parentNode.insertBefore(this.instructions, this.list.nextSibling);
        },
        /**
         * Validate the config option.
         * @param {Object} config Config object.
         */
        validateConfig: function(config) {
            if (!config.inputSelector) {
                throw new Error('Must set inputSelector.');
            }
            if (this.input === null) {
                throw new Error(`${config.inputSelector} not found in the DOM.`);
            }
            if (!this.queryUrl && this.staticData.length === 0) {
                throw new Error('Must set queryUrl or staticData.');
            }
        },
        /**
         * Set config.
         * @param {Object} config Config object.
         */
        setConfig: function(config) {
            this.input = document.querySelector(config.inputSelector);

            const validConfigs = [
                'queryUrl',
                'staticData',
                'queryProcessor',
                'dataProcessor',
                'selectCallback',
                'resultLimit',
                'queryData',
                'instructionsText',
                'preventSubmit',
                'listLabel',
                'showAllOnFocus',
                'allowEmptySearch'
            ];

            const props = Object.keys(config);
            props.forEach(function(prop) {
                if (validConfigs.indexOf(prop) === -1) {
                    return;
                }
                this[prop] = config[prop];
            }, this);

            if (this.showAllOnFocus) {
                this.allowEmptySearch = true;
            }
        },
        /**
         * Initialize
         * @param {Object} config Config object.
         * @param {String} inputSelector For the input to add autocomplete to.
         * @param {String} queryUrl Url to send ajax requests to
         * @param {Array} staticData Data for autocomplete in lieu of an ajax request.
         * @param {String} instructionsText Translation of instructions for screen readers.
         * @param {Number} [resultLimit] Max results to retrieve/show. Sent with query.
         * @param {Function} [queryProcessor] Function that accepts typed query and returns it transformed for search.
         * @param {Function} [dataProcessor] Function that accepts return data array and formats it.
         * @param {Function} [selectCallback] Function for when a option is selected.
         * @param {Boolean} [queryData] Data to send with the query
         * @param {Boolean} [preventSubmit] Prevent form submit.
         * @param {Boolean} [showAllOnFocus] Show the list on first focus.
         * @param {Boolean} [allowEmptySearch] Allow empty/blank search.
         */
        init: function(config) {
            this.setConfig(config);
            this.validateConfig(config);
            this.formatInput();
            this.createList();
            this.addInstructions();
            this.attachEvents();
        }
    };

    /**
     * Initialize a new autocomplete.
     * @param {Object} config Config object passed to autocomplete.init
     * @return {autocomplete}
     */
    const initAutocomplete = function(config) {
        const a = Object.create(autocomplete);
        a.init(config);
        return a;
    };

    root.springSpace = root.springSpace || {};
    root.springSpace.sui = root.springSpace.sui || {};
    root.springSpace.sui.initAutocomplete = root.springSpace.sui.initAutocomplete || initAutocomplete;
})(this);
;

(function(root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};

    // see QueueConstants
    const AUTOREPLY_TYPE_INACTIVE = 0;
    const AUTOREPLY_TYPE_ALWAYS = 1;
    const AUTOREPLY_TYPE_OFFHOURS = 2;
    const AUTOREPLY_TYPE_SCHEDULED = 3;

    /**
     * Auto reply settings for deciding if captcha should be shown
     * @deprecated prefer usage in js/public/QuestionForm.js for import
     */
    class FormAutoReply {
        /**
         * @prop {Number} type Type of autoreply (see constants)
         * @prop {Number|null} start schedule start date in unix seconds
         * @prop {Number|null} end schedule end date in unix seconds
         * @prop {Boolean} libauth_enabled Is Libauth on for the form
         */
        constructor({
            type = 0,
            start = null,
            end = null,
            offhours = null,
            captchaAlwaysOn = false,
            libauth_enabled = false
        }) {
            this.type = type;
            this.start = start;
            this.end = end;
            this.offhours = offhours;
            this.captchaAlwaysOn = captchaAlwaysOn;
            this.libauth_enabled = libauth_enabled;
        }
        /**
         * Should we enable the captcha because of the autoreply.
         * @returns {Boolean}
         */
        isCaptchaEnabled() {
            if (this.libauth_enabled) {
                return false;
            }
            if (this.captchaAlwaysOn) {
                return true;
            }
            return this.isAutoReplyEnabled();
        }
        /**
         * Is auto-reply enabled.
         * @returns {Boolean}
         */
        isAutoReplyEnabled() {
            if (this.type === AUTOREPLY_TYPE_INACTIVE) {
                return false;
            }
            if (this.type === AUTOREPLY_TYPE_ALWAYS) {
                return true;
            }
            if (this.type === AUTOREPLY_TYPE_SCHEDULED) {
                return this._isBetweenDates();
            }
            if (this.type === AUTOREPLY_TYPE_OFFHOURS) {
                return this._isNowOffHours();
            }
            return false;
        }

        /**
         * Get auto reply type
         * @returns {Number}
         */
        getAutoReplyType() {
            return this.type;
        }
        /**
         * Is now between the start/end timestamps.
         * @returns {Boolean}
         */
        _isBetweenDates() {
            if (!this.end || !this.start) {
                return false;
            }
            // calculate now compared to start/end.
            // milliseconds to unix seconds
            const unixTime = Math.floor(Date.now() / 1000);
            return (unixTime >= this.start
                && unixTime <= this.end);
        }

        _isNowOffHours() {
            // calculate day and hour compared to off hours.
            // @todo refactor offhours so we can get them in UTC
            // for now we'll just calc this in the captcha request endpoint
            return true;
        }
    }

    root.springSpace.la.FormAutoReply = FormAutoReply;
})(window);
;

(function(root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};

    // see QuestionFormConstants
    const ruleConstants = Object.freeze({
        RULE_OPERATOR_EQUALS: 0,
        RULE_OPERATOR_NOTEQUALS: 1,
        RULE_OPERATOR_INCLUDES: 2,
        RULE_OPERATOR_INCLUDES_ALL: 3,
        RULE_ACTION_SHOW: 0,
        RULE_ACTION_HIDE: 1,
        RULE_ACTION_NONE: -1
    });

    /**
     * Field Rules
     * @deprecated prefer usage in js/public/QuestionForm.js for import
     */
    class FormFieldRule {
        /**
         * @prop {Number} field1 Field which can trigger changes
         * @prop {Number} operator Constant for = !=
         * @prop {Array<Number>} value Field 1's value that triggers change
         * @prop {Number} field2 Field that is effected
         * @prop {Number} action Constant for show/hide
         */
        constructor({
            field1 = 0,
            operator = ruleConstants.RULE_OPERATOR_EQUALS,
            value = [],
            field2 = 0,
            action = ruleConstants.RULE_ACTION_SHOW
        }) {
            this.field1 = field1;
            this.operator = operator;
            this.value = Array.isArray(value) ? value : [];
            this.field2 = field2;
            this.action = action;
        }

        get oppositeAction() {
            return this.action === ruleConstants.RULE_ACTION_SHOW
                ? ruleConstants.RULE_ACTION_HIDE
                : ruleConstants.RULE_ACTION_SHOW;
        }
        /**
         * Based on value of field do we hide/show/nothing.
         * @param {Number|Array<Number>} field2value Current field value.
         * @returns {Number}
         */
        getFieldAction(field2value) {
            // if field is reset to no answer then hide
            if (field2value === 0 || field2value.length === 0) {
                return ruleConstants.RULE_ACTION_HIDE;
            }
            switch (this.operator) {
                case ruleConstants.RULE_OPERATOR_EQUALS:
                    return this.value.includes(field2value)
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_NOTEQUALS:
                    return !this.value.includes(field2value)
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_INCLUDES:
                    if (!Array.isArray(field2value)) {
                        return ruleConstants.RULE_ACTION_NONE;
                    }
                    // At least one must match
                    return field2value.filter((el) => {
                        return this.value.includes(el);
                    }).length > 0
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_INCLUDES_ALL:
                    if (!Array.isArray(field2value)) {
                        return ruleConstants.RULE_ACTION_NONE;
                    }
                    // All must match
                    return field2value.filter((el) => {
                        return this.value.includes(el);
                    }).length === this.value.length
                        ? this.action
                        : this.oppositeAction;
            }
            return ruleConstants.RULE_ACTION_NONE;
        }
    }

    root.springSpace.la.FormFieldRule = FormFieldRule;
})(window);
;
/*
    FAQ search form for use in various places
    Added to: public js
    Used in: chat offline js
    Requires: sui-autocomplete
*/

(function(root) {
    var initAutocomplete = root.springSpace.sui.initAutocomplete;

    var faqSearchForm = {
        /**
         * * @prop {Number} id Id of search content item.
         */
        id: 0,
        /**
         * @prop {Number} iid Site instid
         */
        iid: 0,
        /**
         * @prop {String} apiDomain Target for autocomplete queries.
         */
        apiDomain: '',
        /**
         * @prop {Array} groupId Group limiters.
         */
        groupId: 0,
        /**
         * @prop {HTMLElement} form Search form element.
         */
        form: null,
        /**
         * @prop {Number} limit Limit of results to return.
         */
        limit: 10,
        /**
         * @prop {Object} autocomplete SUI Autocomplete object.
         */
        autocomplete: null,
        /**
         * Format the api's returned data into what we need for autocomplete.
         * @param {Object} data Data from the returned API request.
         * @return {Object}
         */
        autcompleteDataFormatCb: function(data) {
            var output = [];
            var results = data.results;
            results.forEach(function(result) {
                result.label = result.question;
                output.push(result);
            });
            return output;
        },
        /**
         * When an autocomplete options is selected
         * @param {HTMLElement} option LI element that was selected.
         */
        autocompleteSelectCb: function(option) {
            // save original input search text before autocomplete selection
            let originalQInput = this.form.querySelector('input[name=originalq]');
            if (originalQInput === null) {
                originalQInput = document.createElement('input');
                originalQInput.setAttribute('type', 'hidden');
                originalQInput.setAttribute('name', 'originalq');
                this.form.insertBefore(originalQInput, this.form.firstChild);
            }
            const searchInput = this.form.querySelector('#s-la-content-search-query-' + this.id);
            originalQInput.value = searchInput.dataset.oldvalue || '';

            var faqInput = this.form.querySelector('input[name=faqid]');
            if (faqInput === null) {
                faqInput = document.createElement('input');
                faqInput.setAttribute('type', 'hidden');
                faqInput.setAttribute('name', 'faqid');
                this.form.insertBefore(faqInput, this.form.firstChild);
            }
            faqInput.value = option.getAttribute('data-faqid');
            this.form.submit();
        },
        /**
         * Instantiate the autocomplete.
         */
        enableAutocomplete: function() {
            try {
                this.autocomplete = initAutocomplete({
                    inputSelector: '#s-la-content-search-query-' + this.id,
                    queryUrl: 'https://' + this.apiDomain + '/faq/searchpublic',
                    dataProcessor: this.autcompleteDataFormatCb.bind(this),
                    selectCallback: this.autocompleteSelectCb.bind(this),
                    queryData: {
                        rows: this.limit,
                        iid: this.iid,
                        group_ids: this.groupId
                    }
                });
            } catch (e) {
                console.log(e.message);
            }
        },
        /**
         * Instantiate the search form.
         * @param {Object} config Config settings.
         * @param {Number} config.contentId Id number of search box.
         * @param {Number} confid.iid Site Instid.
         * @param {String} config.apiDomain Domain to send queries to for autocomplete.
         * @param {Array} config.groupId Group id(s) for search limiter.
         * @param {Number} config.limit Number of autocomplete result to show.
         */
        init: function(config) {
            this.id = config.contentId;
            this.iid = config.iid;
            this.apiDomain = config.apiDomain;
            this.groupId = JSON.stringify(config.groupId); //we use JSON string to pass to API easier
            this.form = document.querySelector('#s-la-content-search-' + this.id + ' form');
            this.limit = (config.limit) ? config.limit : 10;

            this.enableAutocomplete();
        }
    };

    /**
     * Initialize a new autocomplete.
     * @param {Object} config Config object passed to autocomplete.init
     * @return {autocomplete}
     */
    var initFaqSearchForm = function(config) {
        var form = Object.create(faqSearchForm);
        form.init(config);
        return form;
    };

    root.springSpace = this.springSpace || {};
    root.springSpace.la = this.springSpace.la || {};
    root.springSpace.la.initFaqSearchForm = initFaqSearchForm;
})(this);
;
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./js/datepicker/src/base.js
class BaseElement extends HTMLElement {
    static get props() {
        return {};
    }

    static get observedAttributes() {
        return Object.keys(this.props).map((propName) => {
            return this.attributeName(propName);
        });
    }

    static attributeName(propName) {
        return propName.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
    }

    constructor() {
        super();

        // property is element id, value is the element
        // for any element with an id in the shadowroot
        this.$ = {};
        // two objects mapping property name to attribute name (and the reverse)
        this.attrToProp = {};
        this.propToAttr = {};
        Object.keys(this.constructor.props).forEach((name) => {
            const attrName = this.constructor.attributeName(name);
            this.attrToProp[attrName] = name;
            this.propToAttr[name] = attrName;
        });

        this.attachShadow({ mode: 'open' });

        this._renderPromise = null;
        this._isConnected = false;

        // regular reset object of props that changed
        // and triggered a rerender
        this._triggers = {};
        // storing prop name and values
        // seems to proxy them through getters/setters
        this._props = {};
    }

    connectedCallback() {
        if (this._isConnected) {
            return;
        }
        const initialProps = Object.keys(this.constructor.props).reduce(
            (all, propName) => {
                return {
                    ...all,
                    [propName]: this[propName]
                };
            },
            {}
        );

        Object.keys(this.constructor.props).forEach((propName) => {
            const propertyInfo = this.constructor.props[propName];
            const attrName = this.propToAttr[propName];

            let initialValue = this[propName];

            if (this.hasAttribute(attrName)) {
                initialValue = this.getAttribute(attrName);
                if ([Array, Object].includes(propertyInfo.type)) {
                    try {
                        initialValue = JSON.parse(initialValue);
                    } catch (err) {
                        // ignore
                    }
                }
            } else if (initialProps[propName] !== undefined) {
                initialValue = initialProps[propName];
            }

            Object.defineProperty(this, propName, {
                set: this.setter(propName),
                get: this.getter(propName)
            });

            this[propName] = initialValue;
        });

        this._isConnected = true;

        this._render(true, true);
    }

    disconnectedCallback() {
        this._isConnected = false;
    }

    _requestRender() {
        if (!this._renderPromise) {
            this._renderPromise = Promise.resolve().then(() => {
                this._render();
            });
        }
    }

    _render(force = false, first = false) {
        if (
            !force &&
            !Object.keys(this._triggers).length
        ) {
            return;
        }

        this._renderPromise = Promise.resolve().then(() => {
            if (first) {
                this.firstRender(this.shadowRoot, this._triggers);

                this.$ = [...this.shadowRoot.querySelectorAll('[id]')].reduce((all, el) => {
                    return {
                        ...all,
                        [el.id]: el
                    };
                }, {});

                this.firstRendered(this.shadowRoot, this._triggers);
            }

            this.render(this.shadowRoot, this._triggers);
            this.rendered(this.shadowRoot, this._triggers);

            this._renderPromise = null;
            this._triggers = {};
        });
    }

    forceRender() {
        this._render(true);
    }

    firstRender() {}

    render() {}

    firstRendered() {}

    rendered() {}

    setter(propName) {
        const attrName = this.propToAttr[propName];

        return (value) => {
            if (this._props[propName] === value) return;

            if (!(propName in this._triggers)) {
                this._triggers[propName] = this._props[propName];
            }

            this._props[propName] = value;

            const propertyInfo = this.constructor.props[propName];

            if (this._isConnected && this.constructor.observedAttributes.includes(attrName)) {
                let attributeValue = value;

                if (propertyInfo.type === Boolean) {
                    attributeValue = attributeValue || attributeValue === '';
                    if (attributeValue) {
                        this.setAttribute(attrName, '');
                    } else {
                        this.removeAttribute(attrName);
                    }
                } else {
                    if ([Array, Object].includes(propertyInfo.type)) {
                        attributeValue = JSON.stringify(attributeValue);
                    }

                    if (this.getAttribute(attrName) !== attributeValue) {
                        if ([null, undefined].includes(attributeValue)) {
                            this.removeAttribute(attrName);
                        } else {
                            this.setAttribute(attrName, attributeValue);
                        }
                    }
                }
            }

            if (this._isConnected) {
                this._requestRender();
            }
        };
    }

    getter(propName) {
        return () => this._props[propName];
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        const propName = this.attrToProp[attrName];

        const propertyInfo = this.constructor.props[propName];

        let propertyValue = newValue;

        switch (propertyInfo.type) {
            case Boolean:
                propertyValue = propertyValue === '';
                break;
            case Number:
                propertyValue = Number(propertyValue);
                break;
            case Array:
            case Object:
                try {
                    propertyValue = JSON.parse(propertyValue);
                } catch (err) {
                    // ignore
                }
                break;
            case String:
                break;
        }

        if (this[propName] !== propertyValue) {
            this[propName] = propertyValue;
        }
    }
}

/* harmony default export */ const base = (BaseElement);

;// ./js/datepicker/src/date-picker.js
/* eslint-disable no-unused-expressions */


class DatePicker extends base {
    static get props() {
        return {
            date: {
                type: String
            },
            time: {
                type: String
            },
            value: {
                type: Object
            },
            showTime: {
                type: Boolean
            },
            confirmOnDate: {
                type: Boolean
            },
            locale: {
                type: String
            },
            dateStyle: {
                type: Object
            },
            startYear: {
                type: Number
            },
            endYear: {
                type: Number
            },
            startDay: {
                type: Number
            },
            defaultDate: {
                type: String
            },
            defaultTime: {
                type: String
            },
            hasNative: {
                type: Boolean
            },
            useNative: {
                type: Boolean
            },
            alignTop: {
                type: Boolean
            },
            alignRight: {
                type: Boolean
            }
        };
    }

    constructor() {
        super();

        const now = new Date();

        this.showTime = false;
        this.confirmOnDate = false;
        this.alignTop = false;
        this.alignRight = false;
        this.dateStyle = {};
        this.startYear = now.getFullYear() - 100;
        this.endYear = now.getFullYear() + 5;
        this.startDay = 1;

        try {
            const input = document.createElement('input');
            input.type = 'date';
            this.hasNative = input.type === 'date';
        } catch (error) {
            this.hasNative = false;
        }

        this.onLabelClick = this.onLabelClick.bind(this);
        this.onClickOutside = this.onClickOutside.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        document.addEventListener('click', this.onClickOutside);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        if (this._dateInput) {
            [...(this._dateInput.labels || [])].forEach((labelEl) => {
                labelEl.removeEventListener('click', this.onLabelClick);
            });
        }
        document.removeEventListener('click', this.onClickOutside);
    }

    firstRender(_) {
        const template = document.createElement('template');
        template.innerHTML = `
      <style>
        :host {
          position: relative;

          --rgb: var(--aeon-rgb, 0, 0, 0);
          --bgRgb: var(--aeon-bgRgb, 255, 255, 255);
          --color: rgb(var(--rgb));
          --hintColor: rgba(var(--rgb), 0.2);
          --bgColor: rgb(var(--bgRgb));

          color: var(--color);
        }

        ::slotted(input[type=date]),
        ::slotted(input[type=time]) {
          display: none;
        }

        :host([has-native][use-native]) ::slotted(input[type=date]),
        :host([has-native][use-native]) ::slotted(input[type=time]) {
          display: inline-flex;
        }

        :host([has-native][use-native]) slot[name=output] {
          display: none;
        }

        aeon-calendar {
            position: absolute;
            top: 100%;
            left: 0;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            background-clip: padding-box;
            padding: 12px;
        }

        :host([align-top]) aeon-calendar {
          top: auto;
          bottom: 100%;
        }

        :host([align-right]) aeon-calendar {
          left: auto;
          right: 0;
        }

        @media (max-width: 640px) {
          aeon-calendar,
          :host([align-top]) aeon-calendar,
          :host([align-right]) aeon-calendar {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
          }
        }
      </style>

      <slot></slot>
      <slot name="output"></slot>

      <aeon-calendar id="calendar"></aeon-calendar>
    `;

        _.appendChild(template.content.cloneNode(true));
    }

    firstRendered(_) {
        const slot = _.querySelector('slot');
        slot.addEventListener('slotchange', () => {
            const elements = slot
                .assignedNodes()
                .filter((el) => el.nodeType !== Node.TEXT_NODE);
            this._dateInput = elements.find((el) => el.getAttribute('type') === 'date');

            if (this._dateInput) {
                this._output.placeholder = this._dateInput.placeholder;
                (this._dateInput.labels || []).forEach((labelEl) => {
                    labelEl.addEventListener('click', this.onLabelClick);
                });
                this.date = this._dateInput.value;
            }

            this._timeInput = elements.find((el) => el.getAttribute('type') === 'time');

            if (this._timeInput) {
                this.showTime = true;
                this.time = this._timeInput.value;
            }
        });

        this._output = document.createElement('input');
        this._output.slot = 'output';
        this._output.readOnly = true;
        this._output.addEventListener('click', () => {
            this.openCalendar();
        });
        this.appendChild(this._output);

        this.addEventListener('keyup', (event) => {
            event.stopPropagation();
            switch (event.key) {
                case 'Enter':
                    if (!this.$.calendar.open) {
                        this.openCalendar();
                    }
                    break;
            }
        });

        this.$.calendar.addEventListener('change', (event) => {
            this.date = event.target.value.date;
            this.time = event.target.value.time;
            this.closeCalendar();
        });

        this.$.calendar.addEventListener('clear', () => {
            this.date = '';
        });

        this.$.calendar.addEventListener('close', () => {
            if (!this._dontFocus) {
                this._output.focus();
            }

            this._dontFocus = false;
        });
    }

    render(_, triggers) {
        if ('date' in triggers || 'time' in triggers) {
            this.value = {
                date: this.date,
                time: this.time
            };

            this.updateFromString(this.date, this.time);

            this.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );
        }

        if (
            'locale' in triggers ||
      'startYear' in triggers ||
      'endYear' in triggers ||
      'startDay' in triggers ||
      'showTime' in triggers ||
      'confirmOnDate' in triggers
        ) {
            this.updateFromString(this.date, this.time);
        }
    }

    update(date = null) {
        const validDate = date && !isNaN(date);
        let showDate = date;

        if (!validDate) {
            date = this.defaultDate;
            const time = this.defaultTime;
            showDate = this.parseDate(date, time);
        }

        const cal = this.$.calendar;
        cal.year = showDate.getFullYear();
        cal.month = showDate.getMonth();
        cal.day = showDate.getDate();
        cal.hours = showDate.getHours();
        cal.minutes = showDate.getMinutes();
        cal.locale = this.locale;
        cal.startYear = this.startYear;
        cal.endYear = this.endYear;
        cal.startDay = this.startDay;
        cal.showTime = this.showTime;
        cal.confirmOnDate = this.confirmOnDate;

        if (validDate) {
            const dateString = new Intl.DateTimeFormat(this.locale || undefined, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                ...(this.showTime
                    ? {
                        hour: 'numeric',
                        minute: 'numeric'
                    }
                    : {}),
                ...this.dateStyle
            }).format(date);

            this._output.value = dateString;
            if (this._dateInput) {
                this._dateInput.value = this.date;
            }
            if (this._timeInput) {
                this._timeInput.value = this.time;
            }
        } else {
            this._output.value = '';
            if (this._dateInput) {
                this._dateInput.value = '';
            }
            if (this._timeInput) {
                this._timeInput.value = '';
            }
        }
    }

    openCalendar() {
        const rect = this.getBoundingClientRect();
        const fromTop = rect.top;
        const fromBottom = window.innerHeight - rect.bottom;

        this.alignTop = fromBottom < fromTop;

        this.$.calendar.open = true;
    }

    closeCalendar(dontFocus = false) {
        this.$.calendar.open = false;

        this._dontFocus = dontFocus;
    }

    parseDate(date, time) {
        try {
            const dateParts = date.split('-');
            const timeParts = (time || this.defaultTime || '00:00').split(':');

            return new Date(
                dateParts[0],
                parseInt(dateParts[1], 10) - 1,
                dateParts[2],
                timeParts[0],
                timeParts[1]
            );
        } catch (error) {
            return new Date();
        }
    }

    updateFromString(date, time) {
        this.update(this.parseDate(date, time));
    }

    onLabelClick(event) {
        if (!this.useNative || !this.hasNative) {
            event.preventDefault();
            this._output.focus();
        }
    }

    onClickOutside(event) {
        if (this.$.calendar.open) {
            const outsideComponent = !event
                .composedPath()
                .some((element) => element === this);

            if (outsideComponent) {
                this.closeCalendar(true);
            }
        }
    }
}

/* harmony default export */ const date_picker = (DatePicker);

;// ./js/datepicker/src/select.js


class Select extends base {
    static get props() {
        return {
            value: {
                type: Number
            },
            items: {
                type: Array
            }
        };
    }

    constructor() {
        super();

        this.items = [];
    }

    firstRender(_) {
        const template = document.createElement('template');
        template.innerHTML = `
      <style>
        select {
          -webkit-appearance: none;
          -moz-appearance: none;
          padding: 0.5rem;
          padding-right: 1.5rem;
          font-family: inherit;
          font-size: inherit;
          border-radius: 0;
          border: 1px solid var(--hintColor);
          background-color: transparent;
          color: var(--color);
          width: 100%;
        }

        select::-ms-expand {
          display: none;
        }

        .select {
          position: relative;
        }

        .select .indicator {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0.2rem;
          pointer-events: none;
          display: flex;
          align-items: center;
        }
      </style>

      <div class="select">
        <select id="select">
        </select>
        <span class="indicator">
          <svg width="24" height="24">
            <g><path fill="currentColor" d="M7 10l5 5 5-5z"></path></g>
          </svg>
        </span>
      </div>
    `;

        _.appendChild(template.content.cloneNode(true));
    }

    // simulate focus event which doesn't exist as `this` doesn't have (not do
    // we want it to have) a tabIndex
    focus() {
        this.$.select.focus();
    }

    firstRendered() {
        this.$.select.addEventListener('change', (event) => {
            this.value = event.target.value;
        });
    }

    render(_, triggers) {
        if ('value' in triggers) {
            this.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );
        }

        this.$.select.innerHTML = this.items
            .map((item) => `<option value="${item.value}">${item.name}</option>`)
            .join('');

        this.$.select.value = this.value;
    }
}

/* harmony default export */ const src_select = (Select);

;// ./js/datepicker/src/calendar.js
/* eslint-disable no-unused-expressions */


class Calendar extends base {
    static get props() {
        return {
            date: {
                type: String
            },
            time: {
                type: String
            },
            value: {
                type: Object
            },
            showTime: {
                type: Boolean
            },
            confirmOnDate: {
                type: Boolean
            },
            locale: {
                type: String
            },
            startYear: {
                type: Number
            },
            endYear: {
                type: Number
            },
            startDay: {
                type: Number
            },
            year: {
                type: Number
            },
            month: {
                type: Number
            },
            day: {
                type: Number
            },
            hours: {
                type: Number
            },
            minutes: {
                type: Number
            },
            open: {
                type: Boolean
            }
        };
    }

    constructor() {
        super();

        this.showTime = false;
        this.confirmOnDate = false;
        this.open = false;
    }

    connectedCallback() {
        super.connectedCallback();

        this.addEventListener('keydown', this.onKeyDown.bind(this));
    }

    firstRender(_) {
        const template = document.createElement('template');
        template.innerHTML = `
      <style>
        :host {
          display: none;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 3;
          padding: 0.2rem;
          background-color: var(--bgColor);
        }

        :host([open]) {
          display: flex;
        }

        .week {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .day, .date, button {
          color: var(--color);
          background-color: transparent;
          border: 0;
          box-sizing: border-box;
          width: 33px;
          height: 33px;
          padding: 0;
          font-family: inherit;
          font-size: calc(2.8em / 3);

          text-transform: uppercase;

          flex-grow: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .date {
          border: 1px solid var(--hintColor);
          border-width: 0 0 1px 1px;
        }

        .date:last-child {
          border-right-width: 1px;
        }

        .date.last + .spacer {
          border-left-width: 1px;
        }

        .week:nth-child(2) .date:not(.spacer) {
          border-top-width: 1px;
        }

        .week:last-child .spacer {
          border-right-width: 0;
          border-bottom-width: 0;
        }

        .date.today {
            font-weight: bold;
            background-image: linear-gradient(to bottom, #0088cc, #0044cc);
            background-repeat: repeat-x;
            border-color: #0044cc #0044cc #002a80;
            color: #fff;
            font-size: 1.3rem;
        }

        .date.spacer {
          border-left-width: 0;
          pointer-events: none;
        }

        #buttons {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 0.5em;
          padding-top: 0.5em;
          border-top: 1px solid var(--hintColor);
        }

        #year-month, #hours-minutes {
          display: flex;
          width: 100%;
        }

        #year-month aeon-select {
          width: 50%;
        }

        #year-month aeon-select + aeon-select {
          margin-left: 0.5em;
        }

        #hours-minutes {
          padding-top: 0.5em;
          margin-top: 0.5em;
          border-top: 1px solid var(--hintColor);
          display: none;
          justify-content: center;
          align-items: center;
        }

        #hours-minutes aeon-select {
          width: 3.5em;
        }

        #hours-minutes aeon-select#hours {
          margin-right: 0.2em;
        }

        #hours-minutes aeon-select#minutes {
          margin-left: 0.2em;
        }

        :host([show-time]) #hours-minutes {
          display: flex;
        }
      </style>

      <div id="container">
        <div id="year-month">
          <aeon-select id="month"></aeon-select>
          <aeon-select id="year"></aeon-select>
        </div>
        <div id="calendar"></div>
        <div id="hours-minutes">
          <aeon-select id="hours"></aeon-select>:<aeon-select id="minutes"></aeon-select>
        </div>
        <div id="buttons">
          <button id="confirm" title="Confirm">
            <svg width="24" height="24">
              <g><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></g>
            </svg>
          </button>
          <button id="clear" title='Clear'>
            Clear
          </button>
          <button id="cancel" title="Cancel">
            <svg width="24" height="24">
              <g><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></g>
            </svg>
          </button>
        </div>
      </div>
    `;

        _.appendChild(template.content.cloneNode(true));
    }

    firstRendered() {
        this.addEventListener('keyup', (event) => {
            event.stopPropagation();
            switch (event.key) {
                case 'Escape':
                    this.open = false;
                    break;
            }
        });

        this.$.year.addEventListener('change', (event) => {
            this.year = event.target.value;
        });

        this.$.month.addEventListener('change', (event) => {
            this.month = event.target.value;
        });

        this.$.hours.items = [];
        for (let i = 0; i < 24; i++) {
            this.$.hours.items.push({
                name: `${i}`.padStart(2, '0'),
                value: i
            });
        }

        this.$.hours.addEventListener('change', (event) => {
            this.hours = event.target.value;
        });

        this.$.minutes.items = [];
        for (let i = 0; i < 60; i++) {
            this.$.minutes.items.push({
                name: `${i}`.padStart(2, '0'),
                value: i
            });
        }

        this.$.minutes.addEventListener('change', (event) => {
            this.minutes = event.target.value;
        });

        this.$.calendar.addEventListener('click', this.onDateClick.bind(this));

        this.$.cancel.addEventListener('click', () => {
            this.open = false;
        });

        this.$.confirm.addEventListener('click', () => {
            this.confirm();
        });

        this.$.clear.addEventListener('click', () => {
            this.dispatchEvent(
                new Event('clear', {
                    bubbles: true
                })
            );
            this.open = false;
        });
    }

    render(_, triggers) {
        if ('open' in triggers && this.open === false && triggers.open === true) {
            this.dispatchEvent(
                new Event('close', {
                    bubbles: true
                })
            );
        }

        if ('year' in triggers || 'month' in triggers || 'day' in triggers) {
            this.date = this.formatAsDate(this.year, this.month, this.day);
        }

        if ('hours' in triggers || 'minutes' in triggers) {
            this.time = this.formatAsTime(this.hours, this.minutes);
        }

        const now = new Date();
        now.setMonth(0); // not now.setMonth(0, 1) as this can cause issues - see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMonth#Description
        now.setDate(1);

        this.$.year.value = this.year;
        this.$.year.items = [];
        for (let i = this.startYear; i <= this.endYear; i++) {
            this.$.year.items.push({ value: i, name: i });
        }

        this.$.month.value = this.month;
        this.$.month.items = [];
        for (let i = 0; i < 12; i++) {
            const monthNum = now.getMonth();
            this.$.month.items.push({
                value: monthNum,
                name: now.toLocaleString(this.locale || undefined, { month: 'short' })
            });
            now.setMonth(i + 1);
        }
        this.$.month.items.sort((a, b) => a.num - b.num);

        now.setMonth(0);
        now.setDate(1);
        const days = [];
        for (let i = 0; i < 7; i++) {
            const dayNum = now.getDay();
            days.push({
                num: dayNum,
                name: now.toLocaleString(this.locale || undefined, { weekday: 'short' })
            });
            now.setDate(i + 2);
        }
        const startDayOffset = 7 - this.startDay;
        days.sort(
            (a, b) => ((a.num + startDayOffset) % 7) - ((b.num + startDayOffset) % 7)
        );

        this.$.hours.value = this.hours;
        this.$.minutes.value = this.minutes;

        ////

        let workingDate = new Date(this.year, this.month, 1, 12);
        const monthStartDay = workingDate.getDay();

        workingDate.setMonth(workingDate.getMonth() + 1);
        workingDate.setDate(0);
        const daysInMonth = workingDate.getDate();

        workingDate = new Date(this.year, this.month, 1, 12);

        let started = false;
        let finished = false;
        let count = 0;

        this.$.calendar.innerHTML = `
      <div class="week">
        ${days.map((day) => `<div class="day">${day.name}</div>`).join('')}
      </div>

      ${[0, 1, 2, 3, 4, 5]
        .map(() => {
            if (count >= daysInMonth) return null;

            return `
          <div class="week">
            ${days
        .map((day) => {
            const dayNum = day.num % 7;
            if (dayNum === monthStartDay) {
                started = true;
            }

            let date = '';
            if (started) {
                count += 1;
                if (count <= daysInMonth) {
                    date = count;
                    workingDate.setDate(date);
                } else {
                    finished = true;
                }
            }

            const isToday = count === this.day;

            return `
                  <button class="date ${isToday ? 'today' : ''} ${
    !started || finished ? 'spacer' : ''
} ${count === daysInMonth ? 'last' : ''}" data-day="${count}" ${
    !started || finished ? 'tabindex="-1" disabled' : ''
}>${date}</button>
              `;
        })
        .join('')}
          </div>
         `;
        })
        .join('')}
    `;

        const focusableEls = _.querySelectorAll(
            'button:not([disabled]), aeon-select'
        );
        this._firstFocusableEl = focusableEls[0];
        this._lastFocusableEl = focusableEls[focusableEls.length - 1];
    }

    rendered(_, triggers) {
        if (this.open === true) {
            if (
                ('open' in triggers && triggers.open === false) ||
        'day' in triggers
            ) {
                _.querySelector('.today').focus();
            }
        }
    }

    confirm() {
        this.date = this.formatAsDate(this.year, this.month, this.day);
        this.time = this.formatAsTime(this.hours, this.minutes);

        this.value = {
            date: this.date,
            time: this.time
        };

        this.dispatchEvent(
            new Event('change', {
                bubbles: true
            })
        );
    }

    handleTabKey(event) {
        const activeElement = this.shadowRoot.activeElement;

        if (event.shiftKey && activeElement === this._firstFocusableEl) {
            this._lastFocusableEl.focus();
            event.preventDefault();
        } else if (!event.shiftKey && activeElement === this._lastFocusableEl) {
            this._firstFocusableEl.focus();
            event.preventDefault();
        }
    }

    handleArrowKeys(event) {
        let diff = 0;
        switch (event.key) {
            case 'ArrowUp':
                diff = -7;
                break;
            case 'ArrowRight':
                diff = 1;
                break;
            case 'ArrowLeft':
                diff = -1;
                break;
            case 'ArrowDown':
                diff = 7;
                break;
        }

        const date = new Date(this.year, this.month, this.day);
        date.setDate(this.day + diff);
        this.year = date.getFullYear();
        this.month = date.getMonth();
        this.day = date.getDate();
    }

    onKeyDown(event) {
        if (event.key === 'Enter') {
            this.confirm();
        } else if (event.key === 'Tab') {
            this.handleTabKey(event);
        } else if (
            ['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft'].includes(event.key)
        ) {
            this.handleArrowKeys(event);
        }
    }

    onDateClick(event) {
        if (event.target.classList.contains('date')) {
            const button = event.target;
            this.day = parseInt(button.dataset.day, 10);

            if (this.confirmOnDate && !this.showTime) {
                this.confirm();
            }
        }
    }

    formatAsDate(year, month, day) {
        return `${year}-${`${month + 1}`.padStart(2, '0')}-${`${day}`.padStart(
            2,
            '0'
        )}`;
    }

    formatAsTime(hours, minutes) {
        return `${`${hours}`.padStart(2, '0')}:${`${minutes}`.padStart(2, '0')}`;
    }
}

/* harmony default export */ const calendar = (Calendar);

;// ./js/datepicker/src/aeon.js




if (!customElements.get('aeon-select')) {
    customElements.define('aeon-select', src_select);
}
if (!customElements.get('aeon-calendar')) {
    customElements.define('aeon-calendar', calendar);
}
if (!customElements.get('aeon-datepicker')) {
    customElements.define('aeon-datepicker', date_picker);
}

/******/ })()
;
//# sourceMappingURL=aeon-es5.js.map;
/**
 * LA Question Form
 * Requires springSpace.jq and s.ui.filedrop
 * @deprecated js/public/QuestionForm.js is preferred but we have to keep both in sync until we switch over.
 */

(function(root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};
    const AUTOREPLY_TYPE_OFFHOURS = 2;

    /**
     * Question form js
     * @param {Object} config configuration data
     * @param {String} config.form_action Action attribute for the form, set it in js to help with spam??
     * @param {String} config.content_id box_content.id value
     * @param {Number} config.queue_id Form's Queue ID
     * @param {Object} config.errormsg Error message translation object
     * @param {Object} config.translations Translations for the filedrop widget.
     * @param {Boolean} config.libauth_enabled Is Libauth Turned on for this form.
     * @param {Boolean} config.libauth_authed Is the requester validated for libauth.
     * @param {Object} config.autoReplySettings Queue auto reply type, etc.
     * @param {Object[]} config.rules Field rules
     */
    const askform = function(config) {
        this.id = config.content_id;
        this.queue_id = config.queue_id;
        this.errormsg = config.errormsg;
        this.divselector = `#s-la-askform-${this.id}`;
        this.$form = springSpace.jq(`${this.divselector} form`);
        this.translations = config.translations;
        this.form_action = config.form_action;
        this.libauth_enabled = config.libauth_enabled || false;
        this.libauth_authed = config.libauth_authed || false;
        this.autoReplySettings = new root.springSpace.la.FormAutoReply(config.autoReplySettings || {});
        this.captcha_enabled = this.autoReplySettings.isCaptchaEnabled();
        this.autoreply_enabled = this.autoReplySettings.isAutoReplyEnabled();
        this.captchaDiv = this.$form[0].querySelector('.formlibcpt');
        this.confirmEmailDiv = this.$form[0].querySelector('.confem_wrap');
        this.autoreply_type = this.autoReplySettings.getAutoReplyType();
        if (this.captcha_enabled) {
            this.captchaDiv.classList.remove('hidden');
        }
        if (Array.isArray(config.rules)) {
            this.rules = config.rules.map((r) => {
                return new root.springSpace.la.FormFieldRule(r);
            });
        } else {
            this.rules = [];
        }

        /**
         * When a required checkbox is changed we have to adjust the required attribute
         * on all of them else the browser will not validate
         * @param {Event} ev Checkbox input change.
         */
        this.handleRequiredCheckBoxes = function(ev) {
            const fieldName = ev.target.name;
            const isChecked = (ev.target.checked === true);
            // if checked remove required from related inputs.
            if (isChecked) {
                const relatedChecks = this.$form[0].querySelectorAll(`input[type=checkbox][name="${fieldName}"]`);
                if (relatedChecks.length > 0) {
                    Array.prototype.forEach.call(relatedChecks, (el) => {
                        el.removeAttribute('required');
                    }, this);
                }
                return;
            }
            // if unchecked confirm if others are checked.
            const fieldSet = ev.target.closest('fieldset');
            if (fieldSet === null) {
                return;
            }
            // Get checked boxes (if any)
            const checkedBoxes = fieldSet.querySelectorAll('input[type=checkbox]:checked');
            if (checkedBoxes.length > 0) {
                // Others are checked so all good.
                return;
            }
            Array.prototype.forEach.call(fieldSet.querySelectorAll('input[type=checkbox]'), (el) => {
                el.setAttribute('required', '');
            }, this);
        };
        /**
         * Add error on the form
         * @param {HTMLElement} input Element for input/select
         * @param {String} msg Error message
         */
        this.markError = function(input, msg) {
            if (!input) {
                return;
            }
            const msg_div = document.createElement('div');
            msg_div.classList.add('error-message');
            msg_div.innerHTML = msg;
            const parent = input.closest('div.form-group');
            if (parent === null) {
                return;
            }
            input.setAttribute('aria-invalid', 'true');
            parent.classList.add('has-error');
            const label = parent.querySelector('label');
            if (label) {
                label.appendChild(msg_div);
            }
        };
        this.loadCaptcha = function() {
            const url = new URL(this.form_action);
            springSpace.jq.ajax({
                context: this,
                type: 'GET',
                url: `https://${url.hostname}/form/libcpt`,
                data: {
                    queue_id: this.queue_id,
                    auto_type: this.autoReplySettings.type
                },
                dataType: 'json'
            }).done(({ html = '', isNowOffHours = false, isCaptchaAlwaysOn = false }) => {
                if (this.autoreply_type === AUTOREPLY_TYPE_OFFHOURS) {
                    if (!isNowOffHours) {
                        this.autoreply_enabled = false;
                        if (this.confirmEmailDiv) {
                            this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = false;
                            this.confirmEmailDiv.classList.remove('hidden');
                        }
                    }
                    if (!html || (!isCaptchaAlwaysOn && !this.autoreply_enabled)) {
                        this.captchaDiv.classList.add('hidden');
                        return;
                    }
                }

                this.captchaDiv.innerHTML = html;
                this.captchaDiv.classList.add('active');
                this.captchaDiv.classList.remove('hidden');
                const captchaReset = this.captchaDiv.querySelector('.btn-cptreload');
                if (captchaReset) {
                    captchaReset.addEventListener('click', this.loadCaptcha.bind(this));
                }
            }).fail(() => {
                this.captchaDiv.classList.add('hidden');
            });
        };
        /**
         * Validate a single field for if it is set.
         * @param {Object} el DOMElement fields we are validating.
         */
        this.validateField = function(el) {
            if (!el || el.disabled) {
                return;
            }
            if (el.tagName === 'SELECT') {
                const option = el.options[el.selectedIndex] || null;
                if (!option) {
                    return;
                }
                const value = option.value;
                if (value === '' || value === '0') {
                    this.markError(el, this.errormsg.reqfields);
                }
                return;
            }
            if (el.tagName === 'TEXTAREA') {
                if (el.value.trim() === '') {
                    this.markError(el, this.errormsg.reqfields);
                }
                return;
            }
            if (el.tagName !== 'INPUT') {
                return;
            }
            // Ok just INPUT tags now.
            const inputType = el.type;
            // Radio and checkbox are handled as groups
            if (inputType === 'radio' || inputType === 'checkbox') {
                return;
            }
            if (inputType === 'email') {
                if (!el.checkValidity()) {
                    this.markError(el, this.errormsg.emailaddress);
                }
                if (el.name === 'confirm_pemail') {
                    const emailElem = this.$form[0].querySelector('input[name="pemail"]');
                    if (el.value.trim() !== emailElem.value.trim()) {
                        this.markError(el, this.errormsg.emailnotmatch);
                    }
                }
                return;
            }
            // The rest... text mostly.
            if (el.value.trim() === '') {
                this.markError(el, this.errormsg.reqfields);
            }
        };
        /**
         * Validate checkbox and radio groups.
         * @param {HTMLElement} fieldset A fieldset element.
         */
        this.validateFieldSet = function(fieldset) {
            const inputs = fieldset.querySelectorAll('input');
            let isValid = true;
            inputs.forEach((input) => {
                if (!input.checkValidity()) {
                    isValid = false;
                    input.setAttribute('aria-invalid', 'true');
                }
            });
            if (isValid) {
                return;
            }

            const msg_div = document.createElement('div');
            msg_div.classList.add('error-message');
            msg_div.innerHTML = this.errormsg.reqfields;

            fieldset.classList.add('has-error');
            const legend = fieldset.querySelector('legend');
            if (legend) {
                legend.appendChild(msg_div);
                return;
            }
        };
        /**
         * Validate the form before submitting.
         * @return {Boolean}
         */
        this.validate = function() {
            if (this.libauth_enabled && !this.libauth_authed) {
                return false;
            }
            this.$form.attr('action', this.form_action);
            this.$form.find('label .error-message, legend .error-message').remove();
            this.$form.find('.form-group').removeClass('has-error');
            this.$form.find('.form-control, input[type=radio], input[type=checkbox]').attr('aria-invalid', false);

            //check "required fields" for validity
            Array.from(this.$form[0].querySelectorAll('[required]')).forEach((el) => {
                this.validateField(el);
            });
            //check required radio/checkbox groups
            Array.from(this.$form[0].querySelectorAll('fieldset[data-required]')).forEach((el) => {
                this.validateFieldSet(el);
            });

            if (this.$form.find('.has-error').length > 0) {
                this.$form.find('*[aria-invalid=true]:first').trigger('focus');
                return false;
            }
            let qlog_id = 0;
            if (root.springSpace.queryAnalyzer) {
                qlog_id = root.springSpace.queryAnalyzer.qlog_id || 0;
            } else if (root.springSpace.la.Page && root.springSpace.la.Page.qlog_id) {
                qlog_id = root.springSpace.la.Page.qlog_id;
            }
            if (qlog_id > 0) {
                this.$form.find('input[name=qlog]').val(qlog_id);
            }

            root.suiNotify.working();
            return true;
        };

        /**
         * Create a dismissable alert for insertion into the DOM.
         * Uses bootstrap alert classes.
         * @param {String} message HTML Error message (html)
         * @param {String} colorClass Bootstrap based (danger, success, info, etc.)
         * @returns {HTMLElement}
         */
        this.createDismissableAlert = function(message, colorClass) {
            const alert = document.createElement('div');
            alert.classList.add('alert', `alert-${colorClass}`, 'alert-dismissable');
            alert.setAttribute('role', 'alert');
            alert.setAttribute('aria-atomic', 'true');
            const button = document.createElement('button');
            button.type = 'button';
            button.classList.add('close');
            button.setAttribute('aria-label', 'close');
            button.innerHTML = '<span aria-hidden="true">&times;</span>';
            alert.appendChild(button);
            alert.insertAdjacentHTML('beforeend', message);
            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                alert.remove();
            });
            return alert;
        };

        /**
         * Trigger change event on rule fields to reset visibility
         */
        this.resetRules = function() {
            this.rules.forEach((rule) => {
                this.$form[0].querySelectorAll(`*[name="${rule.field1}"], *[name="${rule.field1}[]"]`).forEach((el) => {
                    el.dispatchEvent(new Event('change'));
                });
            });
        };

        /**
         * Instantiate filedrop object to handle validation, submit, error, etc.
         */
        this.questionform = new root.springSpace.sui.filedrop({
            selector: `${this.divselector} form`,
            max_files: 5,
            max_upload_size: 20971520,
            max_file_size: 20971520,
            batch_files: false,
            autoupload: false,
            supportie9: false,
            translations: this.translations,
            callback: (data) => {
                // Insert an alert above the submit button.
                root.suiNotify.hide();
                const alert = this.createDismissableAlert(data.message, 'success');
                const buttonDiv = this.$form[0].querySelector('#s-la-askform-buttons');
                buttonDiv.insertAdjacentElement('beforebegin', alert);
                this.questionform.reset();
                this.resetRules();
                if (this.captcha_enabled) {
                    this.loadCaptcha();
                }
                if (this.autoreply_enabled && this.confirmEmailDiv) {
                    // remove confirmation field when auto reply is enabled
                    this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = true;
                    this.confirmEmailDiv.classList.add('hidden');
                }
            },
            error_callback: (jqXhr) => {
                let error = 'Error';
                const isCaptcha = jqXhr.status === 449;
                if (jqXhr.responseText) {
                    try {
                        const response = JSON.parse(jqXhr.responseText);
                        if (response.error) {
                            error = response.error;
                        }
                    } catch (e) {
                        error = 'Invalid response received';
                    }
                }
                root.suiNotify.hide();
                const alert = this.createDismissableAlert(error, 'danger');
                let errorContain = null;
                let location = 'beforebegin';
                if (isCaptcha) {
                    errorContain = this.$form[0].querySelector('.formlibcpt');
                    if (errorContain) {
                        location = 'afterbegin';
                    }
                }
                if (!errorContain) {
                    errorContain = this.$form[0].querySelector('#s-la-askform-buttons');
                }
                errorContain.insertAdjacentElement(location, alert);
            },
            validate: this.validate.bind(this)
        });

        this.showField = function(field) {
            field.classList.remove('hidden');
            field.querySelectorAll('select, input, textarea').forEach((input) => {
                input.disabled = false;
            });
        };

        this.hideField = function(field) {
            field.classList.add('hidden');
            field.querySelectorAll('select, input, textarea').forEach((input) => {
                if (['checkbox', 'radio'].includes(input.type)) {
                    input.checked = false;
                } else {
                    input.value = '';
                }
                // trigger change event to hide/show fields...
                input.dispatchEvent(new Event('change'));
                input.disabled = true;
            });
        };

        this.getMultiCheckValue = function(fieldname) {
            // get all checkbox values...
            const data = new FormData(this.$form[0]);
            return Array.from(data.getAll(fieldname)).map((el) => {
                return Number(el);
            });
        };

        this.getRadioValue = function(fieldname) {
            const data = new FormData(this.$form[0]);
            return Number(data.get(fieldname));
        };

        this.setUpRules = function() {
            this.rules.forEach((rule) => {
                this.$form[0].querySelectorAll(`*[name="${rule.field1}"], *[name="${rule.field1}[]"]`).forEach((el) => {
                    const field2 = this.$form[0].querySelector(`.${rule.field2}_wrap`);
                    if (!field2) {
                        return;
                    }
                    // then for later...
                    el.addEventListener('change', (ev) => {
                        let fieldValue = Number(ev.target.value);
                        if (ev.target.type === 'checkbox') {
                            // get all checkbox values...
                            fieldValue = this.getMultiCheckValue(ev.target.name);
                        } else if (ev.target.type === 'radio') {
                            fieldValue = this.getRadioValue(ev.target.name);
                        }
                        const action = rule.getFieldAction(fieldValue);
                        if (action === 0) { // show
                            this.showField(field2);
                        } else if (action === 1) { // hide
                            this.hideField(field2);
                        }
                    });
                });
            });
        };

        /**
         * Setup some events on the form.
         * This gets run first.
         */
        this.setUp = function() {
            // LibAuth on but current user not authed
            if (this.libauth_enabled && !this.libauth_authed) {
                // Disable inputs to stop focus
                this.questionform.$form[0].querySelectorAll('input,select,button,textarea').forEach((el) => {
                    el.disabled = true;
                });
                // make tabbable elements and links untabbable.
                this.questionform.$form[0].querySelectorAll('[tabindex="0"],a').forEach((el) => {
                    el.setAttribute('tabindex', '-1');
                });
                // hide form for screenreaders
                this.questionform.$form[0].setAttribute('aria-hidden', 'true');
                // If in iframe set auth link to open in new window.
                if (window !== window.top) {
                    const button = document.querySelector(`${this.divselector} .btn-libauth`);
                    if (button) {
                        button.setAttribute('target', '_blank');
                    }
                }
                return;
            }

            this.setUpRules();

            const reqChecks = this.questionform.$form[0].querySelectorAll('input[type=checkbox][required]');
            if (reqChecks.length > 0) {
                // Add change event for all required checkboxes.
                Array.prototype.forEach.call(reqChecks, function(el) {
                    el.addEventListener('change', this.handleRequiredCheckBoxes.bind(this));
                }, this);
            }
            if (this.captcha_enabled) {
                this.loadCaptcha();
            }
            if (this.autoreply_enabled && this.confirmEmailDiv) {
                // remove confirmation field when auto reply is enabled
                this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = true;
                this.confirmEmailDiv.classList.add('hidden');
            }
        };

        this.setUp();
    };

    root.springSpace.la.askform = askform;
})(window);
;
/**
 * Reusable regular expressions for through LA code
 */
var springSpace = springSpace || {};

springSpace.regex = {
    /**
	 * decent email check without being insane
	 * this will not cover full international addresses which at some point will probably start to be an issue
	 */
    email: /^<?(['a-zA-Z0-9_=\.\-\+&!#\$%\*\?\^\|\{\}\~])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+>?$/i,
    /**
	 * URL check, not perfect
	 */
    url: /^((mailto|https?):)*\/\/.+/i,
    /**
	 * Phone number / sms numbers, no spaces or punctuation
	 * except optional starting +
	 */
    phone: /^\+?[0-9]{10,}$/,
    /**
	 * Date in the format yyyy-mm-dd
	 */
    date: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
    /**
	 * Date time in format yyyy-mm-dd hh:mm with optional :ss
	 */
    datetime: /^[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{1,2}:[0-9]{2}(:[0-9]{2})?$/,
    /**
	 * HTML hex color
	 */
    color: /^#([a-f0-9A-F]{6}|[a-f0-9A-F]{3})$/
};
